import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { NAV_LINKS, SERVICES, SITE } from "@/lib/site-data";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy text-white/85 mt-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="font-serif text-3xl text-white tracking-tight">
            {SITE.name}
          </div>
          <div className="eyebrow mt-2 text-gold">{SITE.title}</div>
          <p className="mt-6 text-sm leading-relaxed text-white/70 max-w-sm">
            {SITE.tagline}
          </p>
          <a
            href={SITE.linkedin}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-linkedin"
            className="mt-8 inline-flex items-center gap-3 text-xs uppercase tracking-[0.22em] font-semibold text-white hover:text-gold transition-colors"
          >
            <Linkedin size={16} />
            LinkedIn
          </a>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-gold">Quick Links</div>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-white/75 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-gold">Practice Areas</div>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link
                  to="/services"
                  data-testid={`footer-service-${s.id}`}
                  className="text-white/75 hover:text-white transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="eyebrow text-gold">Contact</div>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Mail size={14} className="mt-1 text-gold flex-shrink-0" />
              <a
                href={`mailto:${SITE.email}`}
                data-testid="footer-email"
                className="text-white/85 hover:text-white break-all"
              >
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={14} className="mt-1 text-gold flex-shrink-0" />
              <a
                href={`tel:${SITE.phone.replace(/\s/g, "")}`}
                data-testid="footer-phone"
                className="text-white/85 hover:text-white"
              >
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} className="mt-1 text-gold flex-shrink-0" />
              <span data-testid="footer-address" className="text-white/70">
                {SITE.address}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </span>
          <span className="tracking-[0.2em] uppercase">
            Advocate · Bengaluru · India
          </span>
        </div>
      </div>
    </footer>
  );
}
